export enum VehicleType_Enum {
  Unknown = 0,
  Car = 1,
  BlackCab = 2,
  Caravan = 3,
  LCV = 4,
  Motorbike = 5,
  Motorhome = 6,
  Commercial = 7,
  CoachBus = 8,
  Van = 9
}
